export * from './latest-quotes-info.component';